import React from "react";

import { Input } from "../../../../form-inputs/inputs";

const Header = (props) => {
    return (
        <div className="header-info">
            <Input
                name="header"
                label="Panel Header"
                value={props.value}
                updateOnChange={props.updateField}
                autoFocus={!props.isQaEdit}
            />
        </div>
    );
};

export default Header;
